// extracted by mini-css-extract-plugin
export default {"title":"SettingsTitle_title__PnJMO","link":"SettingsTitle_link__Nc-ro","backButton":"SettingsTitle_backButton__CK3xH"};